import { render, staticRenderFns } from "./locally-product.vue?vue&type=template&id=244acf6f"
import script from "./locally-product.vue?vue&type=script&lang=js"
export * from "./locally-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports